import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import FilterBar from './filterBar';
import OmaniChannelDashboard from './dtcDashboard';
import HcpDashboard from './hcpDashboard';
import { fetchDashboardData } from './utility';
import { actions as webMatrixActions } from '../../../redux/reducers/webMatrixReducer';

export default function Dashboard() {
    const dispatch = useDispatch();
    const { company: { id: selectedCompanyId }, isOmaniChannel } = useSelector((state) => state.company);
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const engagerCompanies = [41, 51, 53, 59, 150,72,90,92];
    const { resetToInitialState } = webMatrixActions;

    useEffect(() => {
        const delay = 300;
        let timeout;

        if (selectedCompanyId) {
            timeout = setTimeout(() => {
                fetchDashboardData({
                    dispatch,
                    companyId: selectedCompanyId,
                    startRange: startDateRange,
                    endRange: endDateRange,
                    engagerCompanies,
                    resetToInitialState,
                    isOmaniChannel
                });
            }, delay);
        }

        return () => {
            clearTimeout(timeout);
        };
    }, [selectedCompanyId, startDateRange, endDateRange, isOmaniChannel]);

    return (
        <>
            <FilterBar />
            <Grid container spacing={3}>
                {isOmaniChannel ? <OmaniChannelDashboard companyId = {selectedCompanyId}/> :
                    <HcpDashboard selectedCompanyId={selectedCompanyId} />}
            </Grid>
        </>
    );
}
